var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpanish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2.80371,
    width: 19.6418,
    height: 14.0299,
    rx: 1.96418,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_96_2188",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 20,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 2.80371,
    width: 19.6418,
    height: 14.0299,
    rx: 1.96418,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_96_2188)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.54501H19.6418V2.80371H0V6.54501Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.835H19.6418V13.0937H0V16.835Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.0929H19.6418V6.54565H0V13.0929Z",
    fill: "#FFD133"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14502 9.35303H6.08034V9.82069H5.14502V9.35303Z",
    fill: "#FFEDB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 9.21179H5.60254C5.77019 9.21186 5.90614 9.33762 5.92676 9.49695L5.92871 9.56628L5.83203 10.7313C5.80227 11.0885 5.50295 11.3632 5.14453 11.3632C4.83109 11.363 4.56347 11.1529 4.48145 10.8612L4.45801 10.7313L4.36133 9.56628C4.34557 9.37553 4.49606 9.21179 4.6875 9.21179Z",
    stroke: "#A41517",
    strokeWidth: 0.654728
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21021 9.82013H6.08086V10.2878H5.61319L5.14553 11.2231L4.67787 10.2878H4.21021V9.82013Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.80713,
    y: 8.41736,
    width: 0.935325,
    height: 3.27364,
    rx: 0.467663,
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.54736,
    y: 8.41736,
    width: 0.935325,
    height: 3.27364,
    rx: 0.467663,
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21021 8.23129C4.21021 7.81804 4.54521 7.48303 4.95847 7.48303H5.3326C5.74585 7.48303 6.08086 7.81804 6.08086 8.23129C6.08086 8.33461 5.9971 8.41836 5.89379 8.41836H4.39727C4.29396 8.41836 4.21021 8.33461 4.21021 8.23129Z",
    fill: "#A41517"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanish);
export default __webpack_public_path__ + "static/media/spanish.8e3a41b49e5fa20d162fcf937f7c26b3.svg";
export { ForwardRef as ReactComponent };